import { combineReducers } from "redux";

import currency from "./currency";
import costs from "./costs";
import status from "./status";
import benefits from "./benefits";

export default combineReducers({
  currency,
  costs,
  status,
  benefits,
});
